<div class="menu grey" [ngStyle]="notFlexMenu && {'width': '20em'}" id="navbar-small">
    <ng-template ngFor let-item [ngForOf]="items" let-i="index">
        <a class="item" [routerLink]="item.link" [class.disabled]="item.disabled" routerLinkActive="active" [class.purpleTheme]="color == 'purple'" *checkPermission="item.permission">
            <div class="item-wrapper">
                <div class="icon-wrapper">
                    <div [ngClass]="item.disabled ? 'fill-light-grey' : 'fill-grey'" class="icon" aria-label="Profile" [inlineSVG]=item.svg></div>
                </div>
                <span class="pl-2">{{item.title | translate}} <span *ngIf="item.count >= 0">({{ item.count }})</span></span>
            </div>
        </a>
    </ng-template>
</div>